import React from 'react'
import { useTranslation } from 'react-i18next'
import { AccountContactStep } from 'components/accountContact/AccountContactStep'
import { AccountContactTypes } from 'components/accountContact/helpers/constants'
import { useIdVerification } from 'hooks/useIdVerification'
import { StepDescription } from '../_components/StepDescription'

export const BusinessDirectors = () => {
  const { t } = useTranslation()
  const { isIdVerificationEnabled } = useIdVerification()

  return (
    <>
      <StepDescription
        paragraphs={[
          t('verification.businessDirectors.subHeader'),
          t('verification.businessDirectors.thisCouldBe'),
          ...(isIdVerificationEnabled
            ? [t('verification.businessDirectors.descriptionIdVerification')]
            : []),
        ]}
      />
      <AccountContactStep accountContactType={AccountContactTypes.BUSINESS_DIRECTOR} />
    </>
  )
}
